<template>
  <div class="alert mt-3" :class="summary.valid ? 'alert-success' : 'alert-warning'" style="font-size:12px">
    <div v-for="(msg, i) in summary.messages" :key="i">
      <i class="fa" :class="summary.valid ? 'fa-check-circle' : 'fa-exclamation-triangle'"></i> {{ msg }}
    </div>
    <div class="mt-1 text-muted">
      Mirrors the API: weights sum &gt; 0 · at most one control · no duplicate variant and slide list pair · every variant in the build.
    </div>
  </div>
</template>

<script>
export default {
  name: "ArmsValidation",
  props: { summary: { type: Object, required: true } },
}
</script>
